<template>
  <v-card class="main-content-card" flat>
    <v-toolbar flat>
      <v-toolbar-title>菜单</v-toolbar-title>
      <span class="subheading ml-2">|</span>
      <v-btn color="primary" class="ml-3"
             @click.native.stop="() => { editDbid = null; edit = true; }">新建
      </v-btn>
      <v-spacer/>
      <!--<v-text-field-->
      <!--label="按名称检索…"-->
      <!--v-model="searchName"-->
      <!--v-on:keyup.enter="onSearchName"-->
      <!--append-icon="search"-->
      <!--:append-icon-cb="onSearchName"-->
      <!--/>-->
    </v-toolbar>

    <v-divider/>
    <v-data-table
      :headers="headers"
      :loading="loading"
      hide-actions
      item-key="dbid"
      :pagination.sync="query"
      :items="pageResult.items"
      :total-items="pageResult.total"
      rows-per-page-text="每页记录数"
      no-data-text="没有数据。"
      no-results-text="没有符合条件的记录。"
    >
      <template slot="items" slot-scope="props" style="background-color: aliceblue">
        <td>
          {{ props.index + 1}}
        </td>
        <td>
          <span :class="{'ml-4':props.item.parentId}">
            <v-icon class="mr-1">{{ props.item.icon }}</v-icon>
            {{ props.item.name }}
          </span>
        </td>
        <td>{{ props.item.route }}</td>

        <td class="justify-center layout px-0">
          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   @click="() => { viewDbid = props.item.dbid; view = true; }">
              <v-icon color="teal">more_horiz</v-icon>
            </v-btn>
            <span>查看</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   @click="() => { editDbid = props.item.dbid; edit = true; }">
              <v-icon color="teal">edit</v-icon>
            </v-btn>
            <span>编辑</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   @click="() => { deleDbid = props.item.dbid; deleMsg = props.item.name; dele = true; }">
              <v-icon color="pink">delete</v-icon>
            </v-btn>
            <span>删除</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>

    <x-view
      v-model="view"
      :dbid="viewDbid"
    />

    <x-edit
      v-model="edit"
      :dbid="editDbid"
      v-on:ok="$router.push({path:'./menu', query:{page: 1, ts:`${ts()}`}})"
    />

    <x-delete
      v-model="dele"
      :message="deleMsg"
      :uri="uri"
      :dbid="deleDbid"
      v-on:ok="onDeleOk"
    />

  </v-card>
</template>

<script>
  import Vue from 'vue'

  import XView from './View'
  import XEdit from './Edit'
  import XDelete from '../../global/Delete'

  import mixin from '@/mixin'

  const baseUri = '/api/syst/menu';

  export default {
    // 混入模块主页面（index）基本功能
    mixins: [mixin.index(baseUri)],

    components: {XView, XEdit, XDelete},

    data() {
      return {
        uri: baseUri,
        // 检索、分页、排序条件条件
        query: {
          name: '',
          disabled: '',
          ts:'',

          page: 1,
          rowsPerPage: 25,
          sortBy: null,
          descending: null,
          totalItems: null
        },

        // 检索框
        searchName: '',

        // 表头
        headers: [
          {text: '#', align: 'left', sortable: false, value: 'dbid', width: "20"},
          {text: '菜单名称', align: 'left', sortable: true, value: 'name'},
          {text: '路由 Path', align: 'left', sortable: true, value: 'route'},
          {text: '操作', align: 'center', sortable: false, value: 'dbid', width: "180"}
        ],

        view: false,
        viewDbid: null,

        edit: false,
        editDbid: null,

        dele: false,
        deleDbid: null,
        deleMsg: null
      }
    },

    // 注意，由于加载菜单的URL特殊，所覆盖 mixin 的 beforeRouteEnter 和 beforeRouteUpdate

    // 路由进入前，组件就未完成渲染，不可以使用 this
    beforeRouteEnter(to, from, next) {
      Vue.axios.get(baseUri + "/get/tree", {params: window.xutil.toApiQuery(to.query)})
        .then(
          rsp => next(vm => {
            vm.pageResult = rsp.data;
            vm.loading = false
          })
        )
    },

    // 路由改变前，组件就已经渲染完成，可以使用 this
    beforeRouteUpdate(to, from, next) {
      Vue.axios.get(baseUri + "/get/tree", {params: window.xutil.toApiQuery(to.query)})
        .then(
          rsp => {
            this.pageResult = rsp.data;
            this.loading = false;
            next()
          }
        )
    },

    methods: {
      ts() {
        return Date.now();
      },
      // 检索响应函数
      onSearchName() {
        this.query.name = this.searchName;
      }
    }
  }
</script>
